<template>
  <div class="register-left login">
    <referer-site-info @updateSiteInfo="updateSiteInfo" />
    <div class="regsiter-logo">
      <div class="register-logo-top">
      <img :src="siteLogo" alt :class="isOem ? 'register-logo-oem-img' : 'register-logo-img'"/>
      <div v-show="!isOem" class="register-logo-title">{{ logoText }}</div>
      </div>
      <div class="register-logo-bottom">Find, Analize & Manage Influencers</div>
    </div>
    <div class="register-background-1"></div>
    <div class="register-background-2"></div>
  </div>
</template>

<script>
import RefererSiteInfo from "../oem/RefererSiteInfo.vue";

export default {
name: "authLeft",
components: {
  RefererSiteInfo,
},
provide() {
  return {
    updateSiteInfo: this.updateSiteInfo
  }
},
data() {
  return {
    siteLogo: "",
    logoText: "",
  };
},
computed: {

},
mounted() {
},
methods: {
  updateSiteInfo({siteLogo, logoText, isOem}) {
    this.siteLogo = siteLogo;
    this.logoText = logoText;
    this.isOem = isOem;
  },
},
};
</script>
